import { IndustryConfig } from '../../../types'

export const automotiveServicesExpansionConfig: IndustryConfig = {
  id: 'automotive-services-expansion',
  name: 'Automotive Services - Expansion',
  icon: '🔧',
  description: 'Automotive service providers focused on service expansion and competitive positioning',
  
  businessTypes: [
    {
      id: 'full-service-shop',
      name: 'Full-Service Auto Shop',
      description: 'Complete automotive repair and maintenance services'
    },
    {
      id: 'specialty-service',
      name: 'Specialty Service Provider',
      description: 'Specialized services like transmission, brakes, or electrical work'
    },
    {
      id: 'quick-service',
      name: 'Quick Service Center',
      description: 'Oil changes, inspections, and basic maintenance services'
    },
    {
      id: 'mobile-service',
      name: 'Mobile Auto Service',
      description: 'On-location automotive repair and maintenance services'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'repair-services',
      name: 'Repair Services',
      description: 'Revenue from automotive repair and diagnostic services',
      intelligenceValue: "We'll monitor local repair demand trends, pricing benchmarks, and service gaps to identify expansion opportunities and optimize your service mix."
    },
    {
      id: 'maintenance-contracts',
      name: 'Maintenance Contracts',
      description: 'Recurring revenue from fleet and individual maintenance contracts',
      intelligenceValue: "We'll track fleet maintenance trends, contract pricing, and competitor positioning to help you secure more profitable maintenance agreements."
    },
    {
      id: 'parts-sales',
      name: 'Parts Sales',
      description: 'Revenue from automotive parts sales and markup',
      intelligenceValue: "We'll monitor parts pricing trends, supplier changes, and inventory optimization opportunities to maximize your parts profit margins."
    },
    {
      id: 'additional-services',
      name: 'Additional Services',
      description: 'Revenue from inspections, warranties, and add-on services',
      intelligenceValue: "We'll identify emerging service opportunities, regulatory changes, and customer demand patterns to help you expand your service offerings strategically."
    }
  ],
  
  supplierCategories: [
    {
      id: 'parts-suppliers',
      name: 'Parts Suppliers',
      suppliers: ['AutoZone Commercial', 'NAPA Auto Parts', 'Genuine OEM dealers', 'Local distributors', 'Online suppliers'],
      spendRanges: ['Under $5K', '$5K-$20K', '$20K-$50K', 'Over $50K']
    },
    {
      id: 'equipment-tools',
      name: 'Equipment & Tools',
      suppliers: ['Snap-on', 'Mac Tools', 'Matco Tools', 'Hunter Engineering', 'Automotive lift manufacturers'],
      spendRanges: ['Under $3K', '$3K-$15K', '$15K-$50K', 'Over $50K']
    },
    {
      id: 'facility-operations',
      name: 'Facility & Operations',
      suppliers: ['Shop rent/lease', 'Utilities', 'Insurance providers', 'Waste management', 'Cleaning supplies'],
      spendRanges: ['Under $2K', '$2K-$8K', '$8K-$25K', 'Over $25K']
    },
    {
      id: 'business-services',
      name: 'Business Services',
      suppliers: ['Marketing services', 'Accounting/bookkeeping', 'Software/POS systems', 'Training providers', 'Legal services'],
      spendRanges: ['Under $1K', '$1K-$5K', '$5K-$15K', 'Over $15K']
    }
  ],
  
  competitiveFactors: [
    'Service quality and reliability',
    'Pricing competitiveness',
    'Turnaround time',
    'Location convenience',
    'Equipment capabilities',
    'Technician expertise',
    'Customer service',
    'Warranty offerings',
    'Specialization depth',
    'Fleet partnerships'
  ]
}